<template>
    <div>
        <div class="text-xs text-slate-700 flex flex-col justify-center items-center rounded-sm p-2 w-[220px] max-h-16 overflow-hidden text-slate-700">
            <div class="flex w-full overflow-hidden" style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" :class="{'text-indigo-700': props.isActive}"
                v-html="props.page?.content || ''"></div>
        </div>
    </div>
</template>
<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    page: { type: Object, required: true },
    isActive: { type: Number, required: true },
});
</script>